<template lang="pug">
.item
  Icon(size="xs" :item="item")
  .amount(:class="positiveOrNegative(amount)") {{ formatAmount(amount) }}
</template>

<script>
export default {
  props: [ 'item', 'amount' ],
  methods: {
    formatAmount (amount) {
      return amount > 0 ? '+' + amount : '' + amount
    },

    positiveOrNegative (amount) {
      return amount < 0 ? 'negative' : 'positive'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/buildings/common/Counter.vue